import { render, staticRenderFns } from "./OrderParticularsList.vue?vue&type=template&id=49afaa14&scoped=true&"
import script from "./OrderParticularsList.vue?vue&type=script&lang=js&"
export * from "./OrderParticularsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49afaa14",
  null
  
)

export default component.exports